import React from 'react';
import {
  Button,
  Col,
  Layout,
  Row,
} from 'antd';
import { useTranslation } from 'react-i18next';

import './index.less';

import Logo from '../../components/Logo';

const CUSTOMER_SERVICE_EMAIL = 'customerservice@gasgrid.fi';

const Register = () => {
  const { t } = useTranslation();

  return (
    <Layout className="register__layout">
      <Layout className="register__layout__form-wrapper">
        <Logo
          className="register__layout__form-logo"
          dark
        />
        <Row className="register__layout__form-header">
          <Col span={3} />
          <Col
            span={18}
            align="center"
          >
            <h1>{t('register.unavailable.title')}</h1>
            <p>
              {t('register.unavailable.bodyText')}
              <a href={`mailto:${CUSTOMER_SERVICE_EMAIL}`}>{CUSTOMER_SERVICE_EMAIL}</a>
            </p>
          </Col>
          <Col span={3} />
        </Row>
        <Row className="register__layout__button">
          <Col>
            <Button
              type="primary"
              href="/"
            >
              {t('register.unavailable.button')}
            </Button>
          </Col>
        </Row>
      </Layout>
    </Layout>
  );
};

Register.displayName = 'Register';

export default Register;
